export default __webpack_public_path__ + "static/media/ezrespond-logo.cfbe578f.svg";